import { getPagesCount } from "../getPagesCount";
export function getProgressPageIndex(calcs, progress) {
    return Math.max(Math.min(Math.round(-progress / calcs.step), getPagesCount(calcs) - 1), 0);
}
//# sourceMappingURL=getProgressPageIndex.js.map